import { createContext, useContext, ReactNode, useState, FC } from "react";

import { IValuesFilterUsers, IListUsers, IContextRoot } from "./RootTypes";
import { valuesDefaultFilterUsers } from "./valuesDefaultInputsRoot/ValueDefaultInputRoot";

const RootContext = createContext({} as IContextRoot);

export const RootContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [listUsers, setListUsers] = useState([] as IListUsers[]);

  const [valuesFilterLeads, setValuesFilterLeads] =
    useState<IValuesFilterUsers>(valuesDefaultFilterUsers);

  return (
    <RootContext.Provider
      value={{
        setValuesFilterLeads,
        valuesFilterLeads,
        setListUsers,
        listUsers,
      }}
    >
      {children}
    </RootContext.Provider>
  );
};

export const useContextRoot = (): IContextRoot => useContext(RootContext);
